<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row" ref="tableREF">
        <div
          class="fuel_consumption_row_right_section mr-3 vr__bg"
          style="border-radius: 12px; flex: 0 0 97%; height: 200px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(41, 39, 39 , 0.92), rgb(41, 39, 39, 0.92)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div
            class="row align-items-center justify-content-center"
            style="height: 100%"
          >
            <div
              class="col-md-12"
              style="display: flex; justify-content: center"
            >
              <h4 class="text-center text-white">
                {{ $t("text.createSubAccount.addSubAccount") }}
                <i
                  class="fa fa-user ml-3"
                  style="color: white"
                  aria-hidden="true"
                ></i>
              </h4>
            </div>
          </div>
        </div>
      </div>
      <section class="section__two mt-2">
        <div class="row add_driver_row py-3">
          <div class="col-md-12 col-lg-7 offset-lg-2 add-driver_form_row">
            <div class="driver_form_row mt-5">
              <h6
                class="add_driver_header text-center py-3"
                style="font-size: 20px"
              >
                {{ $t("text.createSubAccount.fillFields") }}
                <svg
                  id="add-user"
                  xmlns="http://www.w3.org/2000/svg"
                  width="20.065"
                  height="20.065"
                  viewBox="0 0 50.065 50.065"
                >
                  <circle
                    id="Ellipse_246"
                    data-name="Ellipse 246"
                    cx="25.032"
                    cy="25.032"
                    r="25.032"
                    transform="translate(0 0)"
                    fill="#337180"
                  />
                  <path
                    id="Path_710"
                    data-name="Path 710"
                    d="M65.317,124.923a24.993,24.993,0,0,0,20.2-10.253c-.846-1.213-4.175-4.756-15.38-7.452a27.419,27.419,0,0,0-.253-4.068,21.908,21.908,0,0,0,3.559-10.935c0-1.011.5-8.18-8.136-8.5V83.7c-.021,0-.04,0-.064,0s-.041,0-.063,0v.011c-8.631.324-8.136,7.494-8.136,8.5A21.9,21.9,0,0,0,60.6,103.15a27.209,27.209,0,0,0-.255,4.068c-10.908,2.625-14.35,6.053-15.3,7.35A24.992,24.992,0,0,0,65.317,124.923Z"
                    transform="translate(-40.286 -74.858)"
                    fill="#448a96"
                  />
                  <circle
                    id="Ellipse_247"
                    data-name="Ellipse 247"
                    cx="6.028"
                    cy="6.028"
                    r="6.028"
                    transform="translate(29.068 32.373)"
                    fill="#00a31f"
                  />
                  <g
                    id="Group_581"
                    data-name="Group 581"
                    transform="translate(31.059 34.341)"
                  >
                    <path
                      id="Path_711"
                      data-name="Path 711"
                      d="M302.106,355.316a.95.95,0,0,1-.951.949h-6.186a.95.95,0,0,1-.95-.949h0a.95.95,0,0,1,.95-.95h6.186a.95.95,0,0,1,.951.95Z"
                      transform="translate(-294.019 -351.273)"
                      fill="#fff"
                    />
                    <path
                      id="Path_712"
                      data-name="Path 712"
                      d="M324.251,333.169a.95.95,0,0,1-.95-.95v-6.186a.95.95,0,0,1,.95-.95h0a.95.95,0,0,1,.951.95v6.186a.95.95,0,0,1-.951.95Z"
                      transform="translate(-320.208 -325.083)"
                      fill="#fff"
                    />
                  </g>
                </svg>
              </h6>
              <div class="text-center driver_btns_div">
                <!-- <button class="mr-3 upload_btn">Uploader Bulk Vehicle <span></span> </button>
                               <button class="download_btn">Download sample <span></span> </button> -->
              </div>
              <div class="Add_driver_form">
                <div class="form_input_section">
                  <!-- <p class="mypara">Username (EMAIL) </p>
                                    <div class="input__div" ref="username_input_div">   
                                        <div class="placeholder_div"> 
                                            <img src="@/assets/img/license-plate.png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                            <input type="text"  placeholder="email@email.com"  @input="captureFormEvents($event)" v-model="email"/>
                                        </div>
                                    </div> -->
                  <div class="input__block" ref="username_input_div">
                    <input
                      type="email"
                      :placeholder="$t('text.createSubAccount.email')"
                      class="form-control"
                      @blur="captureFormEvents($event)"
                      v-model="email"
                    />
                  </div>
                  <div ref="username_error_template"></div>
                </div>
                <div class="form_input_section mt-3">
                  <!-- <p class="mypara">First Name</p>
                                    <div class="input__div" ref="firstname_input_div">
                                        <div class="placeholder_div"> 
                                            <img src="@/assets/img/user1.png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                            <input type="text"  placeholder="First Name"  @input="captureFormEvents($event)" v-model="firstName" />
                                        </div>
                                    </div> -->
                  <div class="input__block" ref="firstname_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.createSubAccount.firstName')"
                      class="form-control"
                      @blur="captureFormEvents($event)"
                      v-model="firstName"
                    />
                  </div>
                  <div ref="firstname_error_template"></div>
                </div>
                <div class="form_input_section mt-3">
                  <!-- <p class="mypara">Last Name</p>
                                    <div class="input__div" ref="lastname_input_div">
                                        <div class="placeholder_div"> 
                                            <img src="@/assets/img/user1.png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                            <input type="text"  placeholder="Last Name"  @input="captureFormEvents($event)" v-model="lastName" />
                                        </div>
                                    </div> -->
                  <div class="input__block" ref="lastname_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.createSubAccount.lastName')"
                      class="form-control"
                      @blur="captureFormEvents($event)"
                      v-model="lastName"
                    />
                  </div>
                  <div ref="lastname_error_template"></div>
                </div>
                <div class="form_input_section mt-3">
                  <!-- <p class="mypara">Phone Number</p>
                                    <div class="input__div" ref="phone_input_div">
                                        <div class="placeholder_div"> 
                                            <img src="@/assets/img/phone.png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                            <input type="text"  placeholder="Phone Number"  @input="captureFormEvents($event)" v-model="phone" />
                                        </div>
                                    </div> -->
                  <div class="input__block" ref="phone_input_div">
                    <input
                      type="text"
                      :placeholder="$t('text.createSubAccount.phoneNumber')"
                      class="form-control"
                      @blur="captureFormEvents($event)"
                      v-model="phone"
                    />
                  </div>
                  <div ref="phone_error_template"></div>
                </div>

                <div class="text-center mt-4">
                  <button
                    class="save__btn record_expense_btn other_btn_4"
                    @click="addSubAccount($event)"
                    :disabled="isButtonDisabled ? true : null"
                    :style="[
                      isButtonDisabled
                        ? { cursor: 'not-allowed' }
                        : { cursor: 'pointer' },
                    ]"
                  >
                    {{ $t("text.createSubAccount.addSubAccount") }}
                    <span></span>
                  </button>
                  <img
                    src="@/assets/img/git_loader.gif"
                    style="display: none"
                    width="35px"
                    class="ml-3 loader"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Customer/MasterLayout.vue";
import backgroundUrl from "@/assets/img/danskebank.jpg";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Create-Sub-Account:: Epump Portal",
  name: "DashboardHome",
  components: {
    MasterLayout,
  },
  data() {
    return {
      backgroundUrl,
      cardBackgroundUrl,
      vehicles: null,
      showLoader: false,
      vehiclesCount: 0,
      email: null,
      firstName: null,
      lastName: null,
      phone: null,
      isButtonDisabled: false,
    };
  },
  methods: {
    changeRoute($newRoute) {
      this.$router.push({ name: $newRoute });
    },
    validEmail(email) {
      var re =
        /^[a-z][a-zA-Z0-9_.]*(\.[a-zA-Z][a-zA-Z0-9_.]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/;
      return re.test(email);
    },
    captureFormEvents($event) {
      if (
        $event.target.placeholder === this.$t("text.createSubAccount.email")
      ) {
        if ($event.target.value === "") {
          this.$refs.username_error_template.style.display = "block";
          // this.$refs.username_error_template.innerHTML = "Email field cannot be blank";
          this.$refs.username_input_div.style.border = "1px solid red";
          this.formIsValid = false;
        } else {
          if (this.validEmail($event.target.value)) {
            this.$refs.username_error_template.style.display = "none";
            this.$refs.username_error_template.innerHTML = "";
            this.$refs.username_input_div.style.border =
              "1px solid rgb(75, 44, 114)";
            this.formIsValid = true;
          } else {
            this.$refs.username_error_template.style.color = "red";
            this.$refs.username_error_template.innerHTML = this.$t(
              "text.errors.invalidEmail"
            );
            this.$refs.username_input_div.style.border = "1px solid red";
            this.formIsValid = false;
          }
        }
      }

      if (
        $event.target.placeholder === this.$t("text.createSubAccount.firstName")
      ) {
        if ($event.target.value === "") {
          this.$refs.firstname_error_template.style.display = "block";
          // this.$refs.firstname_error_template.innerHTML = "First Name field cannot be blank";
          this.$refs.firstname_input_div.style.border = "1px solid red";
          this.$refs.firstname_error_template.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.firstname_error_template.style.display = "none";
          this.$refs.firstname_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
      if (
        $event.target.placeholder === this.$t("text.createSubAccount.lastName")
      ) {
        if ($event.target.value === "") {
          this.$refs.lastname_error_template.style.display = "block";
          // this.$refs.lastname_error_template.innerHTML = "Last Name field cannot be blank";
          this.$refs.lastname_input_div.style.border = "1px solid red";
          this.$refs.lastname_error_template.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.lastname_error_template.style.display = "none";
          this.$refs.lastname_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }

      if (
        $event.target.placeholder ===
        this.$t("text.createSubAccount.phoneNumber")
      ) {
        if ($event.target.value === "") {
          this.$refs.phone_error_template.style.display = "block";
          // this.$refs.phone_error_template.innerHTML = "Phone Number field cannot be blank";
          this.$refs.phone_input_div.style.border = "1px solid red";
          this.$refs.phone_error_template.style.color = "red";
          this.formIsValid = false;
        } else {
          if (
            $event.target.value.length < 10 ||
            $event.target.value.length > 13
          ) {
            this.$refs.phone_error_template.style.display = "block";
            this.$refs.phone_error_template.style.color = "red";
            this.$refs.phone_input_div.style.border = "1px solid red";
            this.$refs.phone_error_template.innerHTML = this.$t(
              "text.errors.shortPhoneNumber"
            );
            this.formIsValid = false;
            return;
          }
          this.$refs.phone_error_template.style.display = "none";
          this.$refs.phone_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = true;
        }
      }
    },
    addSubAccount($event) {
      $event.preventDefault();
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.firstName) {
        this.$toast.open({
          message: this.$t("text.errors.firstNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.lastName) {
        this.$toast.open({
          message: this.$t("text.errors.lastNameMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.phone) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (this.phone.length < 10 || this.phone.length > 13) {
        this.$toast.open({
          message: this.$t("text.errors.shortPhoneNumber"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      let data = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNo: this.phone,
      };
      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/SubAccount/Create`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.createSubAccount.successfullyCreated"),
            type: "success",
            duration: 5000,
          });
          this.$router.push({ name: "sub_accounts" });
          (this.firstName = null), (this.email = null), (this.firstName = null);
          this.lastName = null;
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        });
    },
  },
};
</script>
